import React, { useState } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import { createCompanyApi } from "../../../services/company";
import { useListCompanyCategoriesQuery } from "../../../store/appApi";

const AddCompany = () => {
  const navigate = useNavigate();

  // ── GET: company categories for the dropdown — RTK Query ─────────────────
  const { data: catResponse } = useListCompanyCategoriesQuery();
  const categories = Array.isArray(catResponse?.data) ? catResponse.data : [];

  const [loading, setLoading] = useState(false);

  // ── Local form state ──────────────────────────────────────────────────────
  const [form, setForm] = useState({
    companyName: "",
    companyCategory: "",
    city: "",
  });

  const [errors, setErrors] = useState({});

  // ── Field change ──────────────────────────────────────────────────────────
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  // ── Validation ────────────────────────────────────────────────────────────
  const validate = () => {
    const e = {};
    if (!form.companyName.trim()) e.companyName = "Company Name is required.";
    // if (!form.companyCategory.trim())
    //   e.companyCategory = "Company Category is required.";
    if (!form.city.trim()) e.city = "City is required.";
    return e;
  };

  // ── Submit: POST via direct service call (not RTK Query) ──────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please fill in all required fields correctly.",
      });
      return;
    }

    try {
      setLoading(true);
      await createCompanyApi({
        companyName: form.companyName.trim(),
        // companyCategory: form.companyCategory.trim(),
        city: form.city.trim(),
      });

      Swal.fire({
        icon: "success",
        title: "Company Created!",
        text: `${form.companyName} has been added successfully.`,
        confirmButtonText: "Go to Companies",
      }).then(() => navigate("/all-companies"));
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        "Failed to create company. Please try again.";
      Swal.fire({ icon: "error", title: "Error", text: msg });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => navigate("/companies");

  return (
    <>
      <PageTitle activeMenu="Add Company" motherMenu="Companies" />
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">Company Information</h5>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  {/* ── Company Name ── */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label">
                        Company Name <span className="text-danger">*</span>
                      </label>
                      <input
                        name="companyName"
                        type="text"
                        className={`form-control ${errors.companyName ? "is-invalid" : ""}`}
                        placeholder="Enter company name"
                        value={form.companyName}
                        onChange={handleChange}
                      />
                      {errors.companyName && (
                        <div className="invalid-feedback">
                          {errors.companyName}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* ── Company Category ── */}
                  {/* <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label">
                        Company Category <span className="text-danger">*</span>
                      </label>
                      <select
                        name="companyCategory"
                        className={`form-control ${errors.companyCategory ? "is-invalid" : ""}`}
                        value={form.companyCategory}
                        onChange={handleChange}
                      >
                        <option value="">Select Category</option>
                        {categories.map((cat) => (
                          <option
                            key={cat._id || cat.id}
                            value={cat._id || cat.id}
                          >
                            {cat.name}
                          </option>
                        ))}
                      </select>
                      {errors.companyCategory && (
                        <div className="invalid-feedback">
                          {errors.companyCategory}
                        </div>
                      )}
                    </div>
                  </div> */}

                  {/* ── City ── */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label">City</label>
                      <input
                        name="city"
                        type="text"
                        className={`form-control ${errors.city ? "is-invalid" : ""}`}
                        placeholder="Enter city"
                        value={form.city}
                        onChange={handleChange}
                      />
                      {errors.city && (
                        <div className="invalid-feedback">{errors.city}</div>
                      )}
                    </div>
                  </div>

                  {/* ── Actions ── */}
                  <div className="col-12 mt-3">
                    <button
                      type="submit"
                      className="btn btn-primary me-2"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-1" />
                          Creating...
                        </>
                      ) : (
                        "Create Consultant"
                      )}
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger light"
                      onClick={handleCancel}
                      disabled={loading}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCompany;
